import { Component, Inject, ViewChild, ViewContainerRef, ComponentFactoryResolver, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { InfoDialog } from '../interfaces/info-dialog-data.interface';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-info-dialog',
    templateUrl: 'info-dialog.component.html',
    styleUrls: ['info-dialog.component.scss'],
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule
    ]
})
export class InfoDialogComponent implements AfterViewInit {
    @ViewChild('contentHost', { read: ViewContainerRef, static: true })
    public contentHost!: ViewContainerRef;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: InfoDialog,
        private resolver: ComponentFactoryResolver
    ) {}

    public ngAfterViewInit(): void {
        const factory = this.resolver.resolveComponentFactory(this.data.component);

        this.contentHost.clear();
        this.contentHost.createComponent(factory);
    }
}
